import React, { Component } from 'react';
import {apiGenerateWalletPass, apiPostClientCarteTpDownload} from '../../Api/CarteTp/CarteTp';
import { CarteTpTemplate } from './../../Templates/index';
import { connect } from 'react-redux';
import { apiGetMembers } from '../../Api/Profile/Profile';

class CarteTp extends Component {
  constructor (props) {
    super(props);
    const canonical = document.querySelector('link[rel=canonical]');
    this.url = canonical ? canonical.href : document.location.href;
    this.state = {
      check: false,
      validate: false,
      file: {
        attachement: '',
        blob: null,
        url: ''
      },
      civility: 'Mrs',
      firstName: 'xxxx',
      lastName: 'XXXX',
      socialSecurityNumber: '2 XX XX XXX XXX',
      adherentNumber: 'xxxxxx',
      startDateValidity: "xx/xx/xxxx",
      endDateValidity: "xx/xx/xxxx",
      showErrorModalOpen:false
    };
  }

  checkBoxClicked = () => {
    this.setState({
      check: !this.state.check,
      validate: false
    });
  };

  getFile = async () => {
    const res = await apiPostClientCarteTpDownload();
    console.log("RESS", res)
    // this.props.user?.memberId,
    // this.props.user?.memberNumber,
    // this.props.user?.memberType
    if (res.status == 200) {
      const { blob, url } = await this.createBlob(
        res.carteTP.attachmentData.type,
        res.carteTP.attachmentData.data
      );
      this.setState({
        file: {
          attachement: res.carteTP.attachmentData,
          blob: blob,
          url: `${url}`
        },
        startDateValidity: res.infoCarteTP?.startDate || "xx/xx/xxxx",
        endDateValidity: res.infoCarteTP?.endDate || "xx/xx/xxxx",
      });
    }
  };

  createBlob = async (type, data) => {
    try {
      const blob = await (await fetch(`data:${type};base64,${data}`)).blob();
      const url = URL.createObjectURL(blob);
      return { blob, url };
    } catch (err) {}
  };

  handleSharing = async () => {
    if (navigator.share && this.state.file.blob) {
      var file = new File(
        [this.state.file.blob],
        this.state.file.attachement.name,
        { type: this.state.file.attachement.type }
      );
      await navigator.share({ files: [file] });
    }
  };

  /**
   *
   * @param platform 0 = iOS | 1 = Android
   */
  addPassToWallet = async (platform) => {

    this.setState({addPassInProgress: true})

    if (!this.state.addPassInProgress) {
      const openUrlWallet = (url) => {
        const urlToOpen = document.createElement('a');
        urlToOpen.setAttribute('href', url);
        urlToOpen.setAttribute('target', '_blank');
        urlToOpen.setAttribute("download", "Carte Tiers Payant - Ajouter au Wallet")
        urlToOpen.click();
      }

      const response = await apiGenerateWalletPass(platform)

      if (response.status === 200) {
        if (platform === 0) {
          try {
            const { url } = await this.createBlob(
                "application/vnd.apple.pkpass",
                response.data
            );
            openUrlWallet(url)
          } catch (e) {
            alert("Impossible d'enregistrer le pass.")
          }
          this.setState({addPassInProgress: false})
        } else {
          try {
            openUrlWallet(response.data)
          } catch (e) {
            alert("Impossible d'enregistrer le pass. Vérifiez que Google Pay est disponible sur votre téléphone.")
          }
          this.setState({addPassInProgress: false})
        }
      } else {
        alert("Une erreur est survenue. Veuillez ré-essayer plus tard.")
        this.setState({addPassInProgress: false})
      }
    }

  }


  componentDidMount () {
    this.getFile();
    this.getMember();
  }

  getMember = async () => {
    const response = await apiGetMembers(this.props.user.memberId);
    if (response.status === 200) {
      console.log(response);
      this.setState({
        firstName: response.firstName,
        lastName: response.lastName,
        socialSecurityNumber: response.socialSecurityNumber,
        adherentNumber: response.cgrmContractingCode? response.cgrmContractingCode : response.number
      });
    } else {
      alert('Une erreur est survenue. Veuillez ré-essayer.');
    }
  };

 
  download = async () => {
    try {
      if (!this.state.file.url) {
        await this.getFile();
      }
      this.triggerDownload();
    } catch {
      this.setState({ showErrorModalOpen: true });
    }
  };

  triggerDownload = () => {
    if (!this.state.file.url) {
      this.setState({ showErrorModalOpen: true });
      return;
    }

    const download = document.createElement('a');
    download.setAttribute('href', this.state.file.url);
    
    if (this.state.file.attachement.type === 'application/pdf') {
      download.setAttribute('target', '_blank');
    }
    
    download.click();
  };

  onCloseErrorModal = () => {
    this.setState({
      showErrorModalOpen: false
    });
  };
  
  validateClicked = () => {
    this.setState({
      validate: true
    });
  };

  render () {
    return (
      <CarteTpTemplate
        check={this.state.check}
        checkBoxClicked={this.checkBoxClicked}
        validateClicked={this.validateClicked}
        validate={this.state.validate}
        download={this.download}
        handleSharing={this.handleSharing}
        civility={this.state.civility}
        firstName={this.state.firstName}
        lastName={this.state.lastName}
        socialSecurityNumber={this.state.socialSecurityNumber}
        adherentNumber={this.state.adherentNumber}
        startDateValidity={this.state.startDateValidity}
        endDateValidity={this.state.endDateValidity}
        addPassToWallet={this.addPassToWallet}
        addPassInProgress={this.state.addPassInProgress}
        showErrorModalOpen={this.state.showErrorModalOpen}
        onCloseErrorModal={this.onCloseErrorModal}
      />
    );
  }
}
const mapStateToProps = state => ({
  user: state.auth.user
});
const mapDispatchToProps = dispatch => {
  return {
    dispatch: action => {
      dispatch(action);
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(CarteTp);
